import React, { Component } from 'react';
import { connect } from 'react-redux';
import { WithStyles } from 'decorators/withStyles';

import GroupOutline from '@eduzz/houston-icons/GroupOutline';

interface IState {
  open?: boolean;
}

interface IProps {
  content?: any;
  classes?: any;
}
@WithStyles({
  content: {
    display: 'flex',
    alignItems: 'center',
    justifyItems: 'space-between',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
    padding: 15,
    backgroundColor: '#ECEFF1',
    borderRadius: 5,
  },
  titleTopic: {
    fontSize: 18,
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    width: '100%',
    justifyContent: 'space-between',
    color: '#37474F',
    fontWeight: 600,
  },

  numberPosts: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-around',
    height: 40,
    textTransform: 'uppercase',
  },
  titleContent: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    fontWeight: 600,
  },
})
class LessonTopics extends Component<IProps, IState> {
  constructor(props: any) {
    super(props);
    this.state = { open: true };
  }

  handleClickDialog = () => {
    this.setState({ open: !this.state.open });
  };

  componentDidMount() {}

  selectTopic = () => {
    window.open(
      window.location.href + '/forum/' + this.props.content.content + `?page=1&contentId=${this.props.content.id}`
    );
  };

  render() {
    if (!this.props) return null;

    const { classes, content } = this.props;

    return (
      <div className={classes.content} id='lesson-forum'>
        {
          <div className={classes.titleTopic} onClick={this.selectTopic}>
            <div className={classes.titleContent}>
              <GroupOutline size={30} />
              <div>{content.title}</div>
            </div>
            <div className={classes.numberPosts}>
              {content.replies}
              <small style={{ fontSize: 16, textTransform: 'uppercase' }} id='lesson-forum-posts'>
                Postagens
              </small>
            </div>
          </div>
        }
      </div>
    );
  }
}

const mapStateToProps = (state: any, ownProps: any) => {
  return {
    ...ownProps,
  };
};

export default connect(mapStateToProps)(LessonTopics);
